module.exports = __webpack_public_path__ + "static/img/NorthVanMitsubishilogo.4c0daaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/autoshoplogo/NorthVanMitsubishilogo.jpg
// module id = rGlQ
// module chunks = 0